/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Sso_X15_ConflictInputs */

const en_signin_sso_x15_conflict = /** @type {(inputs: Signin_Sso_X15_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This address is already linked to another person in the workspace. Ask your admin to check it.`)
};

/** @type {(inputs: Signin_Sso_X15_ConflictInputs) => LocalizedString} */
const ar_signin_sso_x15_conflict = en_signin_sso_x15_conflict;

/** @type {(inputs: Signin_Sso_X15_ConflictInputs) => LocalizedString} */
const he_signin_sso_x15_conflict = en_signin_sso_x15_conflict;

/** @type {(inputs: Signin_Sso_X15_ConflictInputs) => LocalizedString} */
const ur_signin_sso_x15_conflict = en_signin_sso_x15_conflict;

/** @type {(inputs: Signin_Sso_X15_ConflictInputs) => LocalizedString} */
const es_signin_sso_x15_conflict = en_signin_sso_x15_conflict;

/** @type {(inputs: Signin_Sso_X15_ConflictInputs) => LocalizedString} */
const fr_signin_sso_x15_conflict = en_signin_sso_x15_conflict;

/** @type {(inputs: Signin_Sso_X15_ConflictInputs) => LocalizedString} */
const de_signin_sso_x15_conflict = en_signin_sso_x15_conflict;

/** @type {(inputs: Signin_Sso_X15_ConflictInputs) => LocalizedString} */
const pt_signin_sso_x15_conflict = en_signin_sso_x15_conflict;

/** @type {(inputs: Signin_Sso_X15_ConflictInputs) => LocalizedString} */
const hi_signin_sso_x15_conflict = en_signin_sso_x15_conflict;

/** @type {(inputs: Signin_Sso_X15_ConflictInputs) => LocalizedString} */
const bn_signin_sso_x15_conflict = en_signin_sso_x15_conflict;

/**
* | output |
* | --- |
* | "This address is already linked to another person in the workspace. Ask your admin to check it." |
*
* @param {Signin_Sso_X15_ConflictInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_sso_x15_conflict = /** @type {((inputs?: Signin_Sso_X15_ConflictInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Sso_X15_ConflictInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_sso_x15_conflict(inputs)
	if (locale === "he") return he_signin_sso_x15_conflict(inputs)
	if (locale === "ur") return ur_signin_sso_x15_conflict(inputs)
	if (locale === "es") return es_signin_sso_x15_conflict(inputs)
	if (locale === "fr") return fr_signin_sso_x15_conflict(inputs)
	if (locale === "de") return de_signin_sso_x15_conflict(inputs)
	if (locale === "pt") return pt_signin_sso_x15_conflict(inputs)
	if (locale === "hi") return hi_signin_sso_x15_conflict(inputs)
	if (locale === "bn") return bn_signin_sso_x15_conflict(inputs)
	return /** @type {LocalizedString} */ ("This address is already linked to another person in the workspace. Ask your admin to check it.")
});